import { useTranslation } from "react-i18next";

import BaseStepper from "@/components_v2/Stepper/BaseStepper";
import EmailStep from "./components/EmailStep";
import PersonalDetailsStep from "./components/PersonalDetailsStep";
import SubmissionConfirmation from "./components/SubmissionConfirmation";
import { APPLY_STEP, useApplyToJoin } from "./hooks/useApplyToJoin";

import "./styles.css";

const ApplyToJoin = () => {
  const { t } = useTranslation();
  const {
    currentStep,
    form,
    organizations,
    hasNoMatchingOrganization,
    result,
    isCheckingEmail,
    isSubmitting,
    handleNext,
    handleBack,
    handleSubmit,
  } = useApplyToJoin();

  const stepperItems = [
    { title: t("applications.labels.getStartedStep") },
    { title: t("applications.labels.personalDetailsStep") },
  ];

  if (result) {
    return <SubmissionConfirmation result={result} />;
  }

  return (
    <div className="apply-to-join full-width">
      <BaseStepper
        className="apply-to-join__stepper"
        current={currentStep}
        items={stepperItems}
      />

      {currentStep === APPLY_STEP.EMAIL ? (
        <EmailStep
          form={form}
          hasNoMatchingOrganization={hasNoMatchingOrganization}
          isCheckingEmail={isCheckingEmail}
          handleNext={handleNext}
        />
      ) : (
        <PersonalDetailsStep
          form={form}
          organizations={organizations}
          isSubmitting={isSubmitting}
          handleBack={handleBack}
          handleSubmit={handleSubmit}
        />
      )}
    </div>
  );
};

export default ApplyToJoin;
